import React from 'react'
import {Svg} from '@modifi/ui'

export default ({...props}) => (
  <Svg viewBox="0 0 150 150" {...props}>
    <g fill="none" fillRule="evenodd" transform="translate(34 34)">
      <path
        d="m41 0c-22.6443441 0-41 18.3554585-41 40.9995591s18.3565376 41.0004409 41 41.0004409 41-18.3563403 41-41.0004409-18.3556559-40.9995591-41-40.9995591z"
        fillRule="nonzero"
        stroke="#51565c"
        strokeWidth="3.5"
      />
      <path d="m25 25h9v9h-9z" fill="#7bb835" />
      <path d="m49 25h9v9h-9z" fill="#7bb835" />
      <path
        d="m41.3941277 68.3333333c-13.0925645 0-24.0807762-8.068052-26.9204063-18.860699-.1077102-.4080776 2.5975049-1.2373402 2.5975049-1.2373402 2.3313453 9.5920077 12.3510561 16.8238065 24.3229014 16.8238065 11.9727354 0 21.9924462-7.2317988 24.3237915-16.8238065 0 0 2.7141167.791688 2.6126378 1.182289-2.8173761 10.8206096-13.8216107 18.9157502-26.9364293 18.9157502z"
        fill="#51565c"
      />
    </g>
  </Svg>
)
